exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#project_manager_page .fa-trash-o[data-v-7f07fa0a] {\n  font-size: 1.4rem;\n  padding: 0.1rem;\n}\n#project_manager_page button[data-v-7f07fa0a]:disabled {\n  cursor: not-allowed;\n}\n#project_manager_page button[data-v-7f07fa0a]:disabled:hover {\n  color: white;\n}", ""]);

// exports
